import {Colors, Texts} from 'appearance'
import {React, styled} from 'common'
import {PageContent} from 'components/Page'
import DanceRequestCard from './DanceRequestCard'

const DanceRequestList = ({dance, t}) => {
    const danceName = `${t('danceName', {
        name: dance.name,
    })}`

    return (
        <DanceContainer key={`pending_${dance.name}`}>
            <Title>{danceName}</Title>
            <MediaList>
                {dance.media?.map((media) => (
                    <DanceRequestCard
                        key={media._id}
                        media={media}
                        dance={dance}
                    />
                ))}
            </MediaList>
        </DanceContainer>
    )
}

export default DanceRequestList

const DanceContainer = styled(PageContent)`
    flex-direction: column;
    @media (max-width: 788px) {
        flex-direction: column;
        align-items: center;
    }
`
const MediaList = styled.div`
    display: flex;
    flex-wrap: wrap;
`

const Title = styled(Texts.Title)`
    color: ${Colors.TORQUISE};
`
